import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/golden-ratio-calculator',
  component: () => import('../../routes/GoldenRatioCalculator.svelte'),
  card: {
    id: 'golden-ratio-calculator',
    title: 'Golden Ratio Calculator',
    description: 'Explore the golden ratio φ ≈ 1.618. Calculate golden divisions, apply φ factors, and discover how this mathematical constant appears in nature, art, and design.',
    icon: 'auto_awesome',
    iconBgClass: 'bg-amber-50',
    iconTextClass: 'text-amber-600',
    href: '/golden-ratio-calculator',
    category: 'Conversion & Math',
  },
  seo: {
    title: 'Golden Ratio Calculator – Explore φ ≈ 1.618 Free',
    description: 'Free golden ratio calculator to calculate φ from two segments, apply golden ratio factors to any value, and discover the mathematical constant behind nature and design.',
  },
};

export default meta;
